import { useInfiniteQuery } from '@tanstack/react-query';
import type { AgentApiMetaMessagesIndex } from '@/types/serializers';

export type ChatThreadScope = 'mine' | 'all';

// ヘッダーのメッセージ受信箱: 候補者ごとの最終メッセージ通知一覧を取得する
export default function useFetchCandidateChatThreads(scope: ChatThreadScope, enabled = true) {
  return useInfiniteQuery({
    enabled,
    queryKey: ['metaMessages', scope],
    queryFn: async ({ pageParam = 1 }) => {
      const apiScope = scope === 'mine' ? 'self' : 'all';
      const response = await fetch(
        `/agent/api/meta/messages.json?scope=${apiScope}&page=${pageParam}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch meta messages (status: ${response.status})`);
      }
      const data: AgentApiMetaMessagesIndex = await response.json();
      return data;
    },
    getNextPageParam: (lastPage, allPages) =>
      lastPage.is_last_page ? undefined : allPages.length + 1,
    initialPageParam: 1,
    refetchOnWindowFocus: true,
  });
}
